import { Variations } from "@utilities/types";
import { FC } from "react";

interface Props {
    variation?: Variations;
}

export const ReadProductVariation:FC<Props> = ({
    variation
})=> {

    if(!variation) return null;

    return (
        <>
            {'sizes' in variation ? (
                <div className="flex flex-wrap gap-2">
                {variation.sizes.map((size, i) => (
                    <span key={i} className="px-2 py-1 bg-gray-100 rounded-full text-sm">
                    {size.size} ({size.quantity})
                    </span>
                ))}
                </div>
            ) : 'colors' in variation ? (
                <div className="flex flex-wrap gap-4">
                {variation.colors.map((color, i) => (
                    <div key={i} className="flex items-center text-sm gap-1">
                    <span
                        className="inline-block w-4 h-4 rounded-full border"
                        style={{ backgroundColor: color.color }}
                    />
                    ({color.quantity})
                    </div>
                ))}
                </div>
            ) : 'colorSizeData' in variation ? (
                <div className="space-y-2">
                {variation.colorSizeData.map((colorSize, i) => (
                    <div key={i} className="text-sm">
                    <div className="flex items-center gap-2">
                        <span
                        className="inline-block w-4 h-4 rounded-full border"
                        style={{ backgroundColor: colorSize.color }}
                        />
                        :
                        <div className="flex flex-wrap gap-2">
                        {colorSize.sizes.map((size, j) => (
                            <span
                            key={j}
                            className="px-2 py-1 bg-gray-100 rounded-full"
                            >
                            {size.size} ({size.quantity})
                            </span>
                        ))}
                        </div>
                    </div>
                    </div>
                ))}
                </div>
            ) : (
                <p className="text-sm">Quantité : {variation.quantity}</p>
            )}
        </>
    )
}
